/* ===========================================================================
   Winkler: product gallery thumbnail slider arrows (desktop)
   Rendered by snippets/product-gallery.liquid when a product has 4+ media,
   styled/scoped in custom.css (.wk-thumbs-arrow, main product page only).
   Uses event delegation so it survives Prestige's <product-rerender> swaps.
   =========================================================================== */
(function () {
  'use strict';

  var SCROLLER = '.product-gallery__thumbnail-scroller';
  var GAP_FALLBACK = 14;

  function scrollerFor(arrow) {
    var list = arrow.closest('.product-gallery__thumbnail-list');
    return list ? list.querySelector(SCROLLER) : null;
  }

  function updateArrows(scroller) {
    var list = scroller.closest('.product-gallery__thumbnail-list');
    if (!list) return;
    var prev = list.querySelector('.wk-thumbs-arrow--prev');
    var next = list.querySelector('.wk-thumbs-arrow--next');
    if (!prev || !next) return;
    var max = scroller.scrollWidth - scroller.clientWidth - 1;
    var pos = Math.abs(scroller.scrollLeft); /* RTL scrollLeft goes negative */
    prev.disabled = pos <= 1;
    next.disabled = pos >= max;
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.wk-thumbs-arrow');
    if (!arrow) return;
    var scroller = scrollerFor(arrow);
    if (!scroller) return;

    var thumb = scroller.querySelector('.product-gallery__thumbnail:not([hidden])');
    var gap = parseFloat(getComputedStyle(scroller).columnGap) || GAP_FALLBACK;
    var step = (thumb ? thumb.getBoundingClientRect().width : scroller.clientWidth / 3) + gap;
    var rtl = getComputedStyle(scroller).direction === 'rtl';
    var dir = parseInt(arrow.dataset.dir, 10) * (rtl ? -1 : 1);
    scroller.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  /* scroll doesn't bubble — capture it, from clicks, swipes or align-selected */
  document.addEventListener(
    'scroll',
    function (event) {
      if (event.target instanceof Element && event.target.matches(SCROLLER)) {
        updateArrows(event.target);
      }
    },
    true
  );

  function refreshAll() {
    document.querySelectorAll(SCROLLER).forEach(updateArrows);
  }

  window.addEventListener('resize', refreshAll);

  /* ------------------------------------------------------------------------
     RTL fix for Prestige's align-selected centering.
     CarouselNavigation.onNavigationChange computes
       offsetLeft - clientWidth/2 + itemWidth/2
     without clamping. In an RTL scroller valid scrollLeft is
     [-(scrollWidth - clientWidth), 0]; the unclamped positive value makes
     Chrome's smooth scrollTo land at the far END of the thumb row on load.
     Patch the prototype to clamp (harmless in LTR), then re-center once.
     ------------------------------------------------------------------------ */
  function patchAlignSelected(Nav) {
    Nav.prototype.onNavigationChange = function (newIndex) {
      this.items.forEach(function (button, index) {
        button.setAttribute('aria-current', newIndex === index ? 'true' : 'false');
      });
      if (
        !this.hasAttribute('align-selected') ||
        (this.scrollWidth === this.clientWidth && this.scrollHeight === this.clientHeight)
      ) {
        return;
      }
      var item = this.items[newIndex];
      if (!item) return;
      var left = item.offsetLeft - this.clientWidth / 2 + item.clientWidth / 2;
      var rtl = getComputedStyle(this).direction === 'rtl';
      var min = rtl ? this.clientWidth - this.scrollWidth : 0;
      var max = rtl ? 0 : this.scrollWidth - this.clientWidth;
      left = Math.max(min, Math.min(max, left));
      this.scrollTo({
        left: left,
        top: item.offsetTop - this.clientHeight / 2 + item.clientHeight / 2,
        behavior: window.matchMedia('(prefers-reduced-motion: no-preference)').matches
          ? 'smooth'
          : 'auto'
      });
    };
  }

  function recenterAll() {
    document.querySelectorAll('product-gallery-navigation[align-selected]').forEach(function (nav) {
      if (typeof nav.onNavigationChange === 'function' && nav.selectedIndex >= 0) {
        nav.onNavigationChange(nav.selectedIndex);
      }
    });
  }

  customElements.whenDefined('product-gallery-navigation').then(function () {
    patchAlignSelected(customElements.get('product-gallery-navigation'));
    /* heal a bad scroll that may have happened before the patch ran */
    recenterAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
